import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import React from "react";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import { notifySomething } from "../_Utils/AppDocuCommon";
import PacketDialogForm from "./_PacketDialogForm";

export default class EditPacketDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevItemId: null,
    };
  } 

  _isMounted = false;
  _loadingItemId = null;

  async componentDidMount() {
    this._isMounted = true;    
    // If dialog is opened and we have an itemId on first mount, load it
    if (this.props.itemId) {
      this.loadPackage(this.props.itemId);
    }
  }

  async componentDidUpdate(prevProps) {
    // Normal prop change: load when itemId changes
    if (this.props.itemId && this.props.itemId !== prevProps.itemId && this._loadingItemId !== this.props.itemId) {
      this.loadPackage(this.props.itemId);
    }
    // HMR / hot-reload or other cases where props didn't change but state was reset
    // If we have an itemId but no itemData and we're not already loading, try loading
    if (this.props.itemId && !this.state.itemData && !this.state.loading && this._loadingItemId !== this.props.itemId) {
      this.loadPackage(this.props.itemId);
    } 
    // Reset state if dialog is closed
    if (!this.props.itemId && prevProps.itemId) {
      this.setState({ itemData: null, loading: false, prevItemId: null });
    }
  }

  componentWillUnmount() { 
    this._isMounted = false;
  }

  // Extracted loader so it can be reused from mount/update and avoids duplicated logic
  loadPackage = async (itemId) => {
    // mark this item as loading to prevent duplicate fetches
    this._loadingItemId = itemId;
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.getPacket(itemId);
      const pkg = res.data.package || {};
      await new Promise((resolve) => setTimeout(resolve, 500)); // sleep 500ms
      if (!this._isMounted) return;
      this.setState({ itemData: pkg, loading: false, prevItemId: itemId });
      this._loadingItemId = null;
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ loading: false });
      this._loadingItemId = null;
      notifySomething('Errore caricamento dati package', 'error');
    }
  };

  updatePackageService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.updatePacket(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating package', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating package:', error);
      notifySomething('Error updating package', 'error');
    } 
  };

  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      name: m.name !== undefined && m.name !== null ? m.name : '',
      description: m.description !== undefined && m.description !== null ? m.description : '',
      ecu_type: m.ecu_type !== undefined && m.ecu_type !== null ? m.ecu_type : '',
      kit_code: m.kit_code !== undefined && m.kit_code !== null ? m.kit_code : '',
      rail_code: m.rail_code !== undefined && m.rail_code !== null ? m.rail_code : '',
      rail2_code: m.rail2_code !== undefined && m.rail2_code !== null ? m.rail2_code : '',
      other_accessories: m.other_accessories !== undefined && m.other_accessories !== null ? m.other_accessories : '',
      status: m.status !== undefined && m.status !== null ? m.status : '',
    };
    // show spinner while updating
    this.setState({ loading: true });
    try {
      await this.updatePackageService(data);
    } finally {
      if (this._isMounted) this.setState({ loading: false });
    }
  }

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
      {loading || !itemData ? (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Packet</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
              <CircularProgress size={40} thickness={4} />
            </div>
          </DialogContent>
        </Dialog>    
      ) : (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Packet</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <PacketDialogForm
              itemData={itemData}
              onChange={newData => this.setState({ itemData: newData })}
              disabled={loading}
              packageCodes={this.props.packageCodes}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose}>Cancel</Button>
            <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
          </DialogActions>
        </Dialog>
      )}
      </>
    );
  }
}
